import { Color } from '../../../../core/models/entities/LogoOptions'
import { isBackupWhiteRow } from '../../../../utils/systemColors'

function ColorBlock({ color, colorHex, size = 'md', forceBackupSwatch = false }: { color?: Color, colorHex?: string, size?: 'sm' | 'md', forceBackupSwatch?: boolean }) {
  // Backup LAYER rows render as a WHITE swatch with a visible border: the
  // stored RGB is a stand-in, not the real colour — pale blue for white
  // backup foil (customer case 21/8, code "0821") and a 0/0/0 dummy for
  // embroidery backup rows like "TONE I TONE" (serial 445790). Identity-gated
  // via isBackupWhiteRow: catalog rows carry isBackup as "printed WITH white
  // backup" and must keep their real colour swatch (regression 21-25/8).
  // Embroidery backup rows do not match the white/0821 identity, so callers
  // with logo context (ColorSwitch) pass forceBackupSwatch instead.
  if (forceBackupSwatch || (color && isBackupWhiteRow(color))) {
    return <BlockBase size={size} background={'#ffffff'} bordered />
  }
  const styleString = color ? `rgb(${color.red}, ${color.green}, ${color.blue})` : colorHex?.charAt(0) === '#' ? colorHex : `#${colorHex!}`

  return <BlockBase size={size} background={styleString} />
}

export function BlockBase({ background, size, bordered = false }: { size: 'sm' | 'md', background: string, bordered?: boolean }) {
  const border = bordered ? ' border border-gray-400' : ''
  switch (size) {
    case 'sm':
      return <div style={{ background }}
                  className={`inline-block min-h-2 min-w-2 h-3 w-3 m-[1.5px] rounded-[1px]${border}`} />
    case 'md':
      return <div style={{ background }}
                  className={`inline-block min-h-3.5 min-w-3.5 h-3.5 w-3.5 m-[1.5px] rounded${border}`} />
  }
}


export default ColorBlock